import { initializeApp, getApps, getApp } from "firebase/app";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { initializeFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = getApps().length ? getApp() : initializeApp(config);
export const rtdb = getDatabase(app);
// experimentalAutoDetectLongPolling lets the SDK fall back from streaming WebChannel
// to long-polling when the network silently drops streams (iOS Safari, some Wi-Fi /
// captive proxies). Without it, devices on those networks log
// "WebChannelConnection RPC 'Listen' stream transport errored" and the SDK enters
// offline mode — which we then mis-render as "Code introuvable".
export const fs = initializeFirestore(app, { experimentalAutoDetectLongPolling: true });
export const fns = getFunctions(app, import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION || "europe-west1");

if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === "true") {
  // Use the same hostname the page was served from so devices loading the SPA
  // over the LAN (e.g. a phone hitting http://192.168.1.63:5174) reach the
  // emulators on the dev machine instead of their own (non-existent) localhost.
  const emulatorHost = window.location.hostname;
  connectDatabaseEmulator(rtdb, emulatorHost, 9000);
  connectFirestoreEmulator(fs, emulatorHost, 8080);
  connectFunctionsEmulator(fns, emulatorHost, 5001);
}
